/**
 * Tab configuration for Catalog Management
 */

import { TabId, MPNUPCSubTabId, TabCounts } from '../types';

// Tab configuration
export const TAB_CONFIG: { id: TabId; label: string }[] = [
  { id: 'sku-matched', label: 'SKU Matched' },
  { id: 'mpn-upc-matched', label: 'MPN/UPC Matched' },
  { id: 'unmatched', label: 'Unmatched' },
  { id: 'ignored-products', label: 'Ignored Products' },
  { id: 'ignored-updates', label: 'Ignored Updates' },
  { id: 'processed', label: 'Processed' },
];

// MPN/UPC sub-tab configuration
export const MPN_UPC_SUB_TAB_CONFIG: { id: MPNUPCSubTabId; label: string }[] = [
  { id: 'unmapped-sku', label: 'Unmapped SKU' },
  { id: 'unmapped-sku-with-updates', label: 'Unmapped SKU with Updates' },
];

// Default tab counts (zeroed until API provides real counts)
export const DEFAULT_TAB_COUNTS: TabCounts = {
  skuMatched: 0,
  mpnUpcMatched: 0,
  unmatched: 0,
  ignoredProducts: 0,
  ignoredUpdates: 0,
  processed: 0,
  missingMapping: 0,
};
